import { Message } from '../models/Message'
import { Container, IInit } from '../../../common/container/Container'
import { Observable } from 'rxjs'
import { Query } from '../../../common/api/Query'
import { IStatusService } from '../../../common/status/StatusService'
import { IMessageApi } from '../api/MessageApi'
import { STATUS_SERVICE_KEY } from '../../../container/app'

type Props = {
  apiKey: symbol
}

export interface IMessageService extends IInit {
  getByID(id: string): Observable<Message | undefined>

  getFilteredItems(q: Query<Message>): Observable<Message[]>

  add(e: Message): Observable<Message | undefined>

  update(e: Message): Observable<Message | undefined>

  delete(e: Message): Observable<boolean>
}

export class MessageService implements IMessageService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IMessageApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IMessageApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  add(e: Message): Observable<Message | undefined> {
    return this._api.add(e)
  }

  delete(e: Message): Observable<boolean> {
    return this._api.delete(e)
  }

  getByID(id: string): Observable<Message | undefined> {
    return this._api.getByID(id)
  }

  getFilteredItems(q: Query<Message>): Observable<Message[]> {
    return this._api.getFilteredItems(q).pipe()
  }

  update(e: Message): Observable<Message | undefined> {
    return this._api.update(e)
  }
}
